<template>
  <div class="contract-presentation">
    <fieldset class="contract-presentation__font">
      <legend>PDF typeface</legend>
      <div class="contract-presentation__choices">
        <label
          v-for="option in ['modern', 'serif']"
          :key="option"
          :class="{ selected: font === option }"
        >
          <input
            type="radio"
            :name="`contract-font-${_uid}`"
            :value="option"
            :checked="font === option"
            @change="$emit('update:font', option)"
          />
          <span
            class="contract-presentation__sample"
            :class="`contract-presentation__sample--${option}`"
            aria-hidden="true"
            >Aa</span
          >
          <span>{{ option === "modern" ? "Modern" : "Serif" }}</span>
        </label>
      </div>
    </fieldset>
    <label class="contract-presentation__bold">
      <input
        type="checkbox"
        :checked="boldValues"
        @change="$emit('update:boldValues', $event.target.checked)"
      />
      <span>
        <strong>Bold values</strong>
        <span class="contract-presentation__hint"
          >Emphasize names, dates and amounts.</span
        >
      </span>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    font: { type: String, default: "modern" },
    boldValues: { type: Boolean, default: true }
  }
};
</script>
<style lang="scss" scoped>
.contract-presentation {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  flex: 0 0 auto;
  gap: 16px 24px;
  width: min(800px, calc(100% - 32px));
  margin: 16px auto 0;
  padding: 16px 20px;
  border: 1px solid #e8e2e5;
  border-radius: 12px;
  background: #faf7f9;
  color: #302a2d;
  font-size: 14px;
}
.contract-presentation__font {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.contract-presentation legend {
  margin-bottom: 8px;
  color: #65565d;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
}
.contract-presentation label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  cursor: pointer;
}
.contract-presentation__choices {
  display: flex;
  gap: 8px;
}
.contract-presentation__choices label {
  min-width: 128px;
  padding: 8px 12px;
  border: 1px solid var(--nvoko-border);
  border-radius: 10px;
  background: #fff;
  transition: border-color 160ms ease, background-color 160ms ease;
}
.contract-presentation__choices label.selected {
  border-color: var(--nvoko-accent-line);
  background: var(--nvoko-accent-tint);
  color: var(--nvoko-wine);
}
.contract-presentation__choices label:hover:not(.selected) {
  background: var(--nvoko-hover);
}
.contract-presentation__sample {
  font-size: 22px;
  line-height: 28px;
}
.contract-presentation__sample--modern {
  font-family: "Plus Jakarta Sans PDF", sans-serif;
}
.contract-presentation__sample--serif {
  font-family: Georgia, "Times New Roman", serif;
}
.contract-presentation__bold {
  padding: 4px 0;
}
.contract-presentation__bold strong {
  display: block;
  font-weight: 500;
  line-height: 22px;
}
.contract-presentation__hint {
  display: block;
  color: #65565d;
  font-size: 13px;
  line-height: 20px;
}
.contract-presentation input {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  accent-color: #ff035a;
}
@media (max-width: 560px) {
  .contract-presentation {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    padding: 12px;
    gap: 12px;
  }
  .contract-presentation__choices {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .contract-presentation__sample {
    display: none;
  }
  .contract-presentation__choices label {
    flex: 1;
    min-width: 0;
    justify-content: center;
    padding: 8px;
    white-space: nowrap;
    line-height: 20px;
  }
  .contract-presentation__bold {
    align-items: flex-start;
    min-height: 0;
    padding: 0;
  }
  .contract-presentation__bold input {
    margin-top: 2px;
  }
}
@media print {
  .contract-presentation {
    display: none;
  }
}
.contract-presentation :focus-visible {
  outline: 2px solid #b40041;
  outline-offset: 3px;
}
</style>
